/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TripForwardingRelationship
 */
export interface TripForwardingRelationship {
    /**
     * 
     * @type {number}
     * @memberof TripForwardingRelationship
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TripForwardingRelationship
     */
    forwardingEmailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof TripForwardingRelationship
     */
    status: TripForwardingRelationshipStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof TripForwardingRelationship
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof TripForwardingRelationship
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const TripForwardingRelationshipStatusEnum = {
    Pending: 'pending',
    Verified: 'verified',
    Revoked: 'revoked'
} as const;
export type TripForwardingRelationshipStatusEnum = typeof TripForwardingRelationshipStatusEnum[keyof typeof TripForwardingRelationshipStatusEnum];


/**
 * Check if a given object implements the TripForwardingRelationship interface.
 */
export function instanceOfTripForwardingRelationship(value: object): value is TripForwardingRelationship {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('forwardingEmailAddress' in value) || value['forwardingEmailAddress'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TripForwardingRelationshipFromJSON(json: any): TripForwardingRelationship {
    return TripForwardingRelationshipFromJSONTyped(json, false);
}

export function TripForwardingRelationshipFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripForwardingRelationship {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'forwardingEmailAddress': json['forwarding_email_address'],
        'status': json['status'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function TripForwardingRelationshipToJSON(json: any): TripForwardingRelationship {
    return TripForwardingRelationshipToJSONTyped(json, false);
}

export function TripForwardingRelationshipToJSONTyped(value?: TripForwardingRelationship | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'forwarding_email_address': value['forwardingEmailAddress'],
        'status': value['status'],
        'created_at': value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'].toISOString(),
    };
}

